<template>
    <div class="row">
        <div class="col-md-3">
            <div class="card custom-card card-body bg-warning tx-white">
                <h6>فیلتر دسته بندی ها</h6>
                <hr class="mb-4 mt-2">
                <label class="ckbox"><input type="checkbox" value="all" id="select-all" checked @change="selectAll"><span>انتخاب همه</span></label>
                <label class="ckbox mt-3" v-for="(category,index) in categories" :key="index"><input type="checkbox" checked @change="changeCategories(category.categoryId)" :value="category.categoryId" :id="'category-' + category.categoryId"><span>{{ category.title }}</span></label>
            </div>
        </div>
        <div class="col-md-9">
            <div class="row" v-if="allCards.length">
                <div class="col-md-4 card-container" v-for="(card,index) in cards" :key="index">
                    <img :src="'https://cardapi.sabinarya.com' + card.address" :alt="card.title">
                    <h5>{{ card.title }}</h5>
                    <div class="row justify-content-center">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>انتخاب مبلغ شارژ</label>
                                <select class="form-control mb-3" v-model="card.depositId">
                                    <option value="61">مبلغ دلخواه</option>
                                    <option v-for="(deposit,index) in depositsList" :key="index" :value="deposit.depositId">{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(deposit.depositValue) }} ریال</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6" v-if="card.depositId == 61">
                            <div class="form-group">
                                <label>مبلغ دلخواه (ریال)</label>
                                <input type="tel" class="form-control ltr-input" v-model="card.depositValue" @keyup="e => changeCustomDepositValue(e,index)" @change="handleMinAndMax">
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-md-12">
                            <div class="form-group">
                                <input type="number" min="0" :id="'theme-count-' + index" class="form-control ltr-input" placeholder="تعداد" value="0" v-model="card.orderCount">
                            </div>
                        </div>
                        <div class="col-md-3 pr-0"><button @click="setCurrent(index)" :disabled="!card.orderCount || card.orderCount < 1 || !card.depositId || (card.depositId == 61 && !card.depositValue) || card.depositValue == 0" data-effect="effect-scale" data-toggle="modal" data-target="#text-and-voice" class="btn ripple btn-success btn-icon btn-block"><i class="fe fe-shopping-cart"></i></button></div>
                    </div>
                </div>
                <div class="modal effect-scale" id="text-and-voice" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content modal-content-demo">
                            <div class="modal-header">
                                <h6 class="modal-title">تنظیمات متن و صدا</h6><button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                            </div>
                            <div class="modal-body">
                                <nav class="nav nav-tabs mb-3">
                                    <a class="nav-link active" data-toggle="tab" href="#visual-text-settings">تنظیمات متن</a>
                                    <a class="nav-link" data-toggle="tab" href="#visual-voice-settings">تنظیمات صدا</a>
                                </nav>                                
                                <div class="tab-content">
                                    <div class="tab-pane active show" id="visual-text-settings">
                                        <div class="form-group">
                                            <label>موضوع</label>
                                            <select class="form-control" v-model="textCategoryId">
                                                <option :value="textCategory.id" v-for="(textCategory,index) in textCategories" :key="index">{{ textCategory.title }}</option>
                                            </select>
                                        </div>
                                        <div class="form-group" v-if="textCategoryId && texts.length">
                                            <label>متن</label>
                                            <select class="form-control" v-model="textId">
                                                <option :value="text.id" v-for="(text,index) in texts" :key="index">{{ text.title }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="visual-voice-settings">
                                        <div class="form-group">
                                            <label>موضوع</label>
                                            <select class="form-control" v-model="voiceCategoryId">
                                                <option :value="voiceCategory.id" v-for="(voiceCategory,index) in voiceCategories" :key="index">{{ voiceCategory.title }}</option>
                                            </select>
                                        </div>
                                        <div class="form-group" v-if="voiceCategoryId">
                                            <label>دسته بندی</label>
                                            <select class="form-control" v-model="voiceSubCategoryId">
                                                <option :value="voiceSubCategory.id" v-for="(voiceSubCategory,index) in voiceSubCategories" :key="index">{{ voiceSubCategory.title }}</option>
                                            </select>
                                        </div>
                                        <div class="form-group" v-if="voiceSubCategoryId && voiceCategoryId && voices.length">
                                            <label>صدا</label>
                                            <select class="form-control" v-model="voiceId">
                                                <option :value="voice.id" v-for="(voice,index) in voices" :key="index">{{ voice.title }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button class="btn ripple btn-success" data-dismiss="modal" type="button" @click="add">افزودن به سبد خرید</button>
                                <button class="btn ripple btn-secondary" data-dismiss="modal" type="button">لغو</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-4 card-container" v-for="index in 8" :key="index">
                    <span class="image-placeholder animate"></span>
                    <h5 class="title-placeholder animate"></h5>
                    <div class="row justify-content-center">
                        <div class="col-md-4"><button class="btn ripple btn-placeholder btn-icon animate btn-add-to-card"></button></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FizicalCard',
    props: ['addToCard','depositsList'],
    data(){
        return {
            allCards: [],
            cards: [],
            categories: [],
            selectedCategories: [],
            cartCards: [],
            cardType: 2,
            currentCard: {},
            currentIndex: 0,
            allTexts: [],
            texts: [],
            textCategories: [],
            textCategoryId: 0,
            textId: 0,
            allVoices: [],
            voices: [],
            voiceCategories: [],
            voiceAllSubCategories: [],
            voiceSubCategories: [],
            voiceCategoryId: 0,
            voiceSubCategoryId: 0,
            voiceId: 0,
            price: 0,
            showLoading: false
        }
    },
    watch: {
        textCategoryId: function(value){
            let getTexts = this.allTexts.filter(text => text.categoryId == value);
        },
        voiceCategoryId: function(value){
            let getSubCategories = this.voiceAllSubCategories.filter(subCategory => subCategory.categoryId == value);
        },
        voiceSubCategoryId: function(value){
            let getVoices = this.allVoices.filter(voice => voice.categoryId == value);
        }
    },
    methods: {
        getData(){
            this.$api.get('Cards/AvailableThemes').then(({data}) => {
                setTimeout(() => {
                    this.allCards = data.result;
                    this.cards = data.result;
                },1000);
            });
            this.$api.get('Cards/Categories').then(({data}) => {
                this.categories = data.result;
                this.categories.map(category => {
                    this.selectedCategories.push(category.categoryId);
                });
            });
            this.$api.get('Config/VirtualCost').then(({data}) => {
                this.price = parseInt(data.result);
            });
        },
        setCurrent(index){
            this.currentIndex = index;
            this.currentCard = this.cards[index];
        },
        add(){
            let themeId = this.currentCard.themeId;
            let title = this.currentCard.title;
            let image = this.currentCard.address;
            let index = this.currentIndex;
            this.addToCard({
                themeId,
                title,
                cardType: this.cardType,
                itemsCount: this.cards[index].orderCount,
                price: this.price,
                imageUrl: image,
                depositId: this.cards[index].depositId,
                depositValue: this.cards[index].depositValue
            });
            this.cards[index].orderCount = null;
            this.cards[index].depositId = null;
            this.cards[index].depositValue = null;
            this.$forceUpdate();
        },
        handleMinAndMax(e){
            let value = parseInt(e.target.value.toString().replace(/,/g,'')) || 0;
            if(value < 200000){
                this.$swal({
                    icon: 'error',
                    title: 'خطا',
                    text: 'کمترین مبلغ شارژ 200,000 ریال می باشد'
                });
                e.target.value = '';
            }
        },
        changeCustomDepositValue(e,index){
            let value = this.cards[index].depositValue ? this.cards[index].depositValue.replace(/,/gi,'') : 0;
            let numbers = /^[0-9]*$/;
            if(!numbers.test(e.target.value)){
                e.preventDefault();
            }
            if(value > 20000000)
                value = 20000000;
            else if(value < 200000){
                value = 0;
                this.$swal({
                    title: 'خطا',
                    icon: 'error',
                    text: 'مبلغ شارژ نمی تواند کمتر از 200,000 ریال باشد',
                    confirmButtonText: 'متوجه شدم'
                });
            }
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.cards[index].depositValue = value;
        },
        setFilterType(element,type){
            let filterTypes = document.getElementsByClassName('filter-item');
            for(let i = 0;i < filterTypes.length;i++){
                if(typeof filterTypes[i] == 'object')
                    filterTypes[i].classList.remove('active');
            }
            element.target.classList.add('active');
        },
        changeCategories(id){
            this.cards = [];
            if(this.selectedCategories.includes(id))
                this.selectedCategories.splice(this.selectedCategories.indexOf(id),1);
            else
                this.selectedCategories.push(id);
            this.selectedCategories.map(categoryId => {
                this.allCards.map(card => {
                    if(card.categories.includes(categoryId))
                        this.cards.push(card);
                });
            });
        },
        selectAll(e){
            this.selectedCategories = [];
            this.cards = [];
            if(e.target.checked)
                this.categories.map(category => {
                    this.selectedCategories.push(category.categoryId);
                    document.getElementById('category-' + category.categoryId).checked = true;
                });
            else
                this.categories.map(category => {
                    document.getElementById('category-' + category.categoryId).checked = false;
                });
            this.selectedCategories.map(categoryId => {
                this.allCards.map(card => {
                    if(card.categories.includes(categoryId))
                        this.cards.push(card);
                });
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>